import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import {retry, takeUntil} from 'rxjs/operators'
import { StorageService } from 'src/app/services/storage.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import KeenSlider, { KeenSliderInstance } from "keen-slider";
import endpoints from 'src/app/helpers/endpoints';
import { MatDialog } from '@angular/material/dialog';
import { FindAgreementNumberModalComponent } from './find-agreement-number-modal/find-agreement-number-modal.component';
import { MapsService } from 'src/app/services/maps.service';
import * as moment from 'moment';
import { SidenavService } from 'src/app/layout/sidenav/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FileClaimSubStep } from 'src/app/enums/file-claim-sub-step.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Location } from '@angular/common';

@Component({
  selector: 'app-add-claim',
  templateUrl: './add-claim.component.html',
  styleUrls: ['./add-claim.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddClaimComponent implements OnInit, AfterViewInit, OnDestroy {
  assetsUrl = environment.assetsUrl + 'images/';
  @ViewChild('homeAddress', { static: false }) public homeAddress!: ElementRef;
  subs: Subscription[] = [];
  step: number = 0;
  subStepTwo: number = 1;
  showZipcodeField: boolean = false;
  submitFullForm: boolean = false;
  addressForm!: FormGroup;
  timeForm!: FormGroup;
  cardDetailsForm !: FormGroup;
  coverItemForm !: FormGroup;
  beforeQuestionForm !: FormGroup;
  afterQuestionForm !: FormGroup;
  claimQuestionForm !: FormGroup;
  issueDateForm !: FormGroup;
  otherAnswerForm !: FormGroup;
  firstQuestionsForm !: FormGroup;
  agreementNumberForm !:FormGroup;
  coverItems: any[] = [];
  claimQuestion: any[] = [];
  afterQuestion: any[] = [];
  beforeQuestion: any[] = [];
  firstQuestions : any[] = [];
  showFirstQuestionForm : boolean = false;
  loading: boolean = false;
  expiryYear: number = Number(new Date().getFullYear().toString().slice(2, 4));
  month = Number(new Date().getMonth() + 1);
  coverItemDetails !: any;
  cardType!: string;
  fileClaimNumber ='';
  panelOpenState = false;
  isOtherAnswer : boolean = false;
  showSubCoverItem !: boolean;
  showSubCoverItemChild !: boolean;
  subCoverItems : any[] = [];
  subCoverItemChild : any[] = [];
  beforeQuestionAnswer: any[] = [];
  afterQuestionAnswer: any[] = [];
  claimQuestionAnswer: any[] = [];
  subCoverItemDetails : any;
  subCoverChildDetais: any;
  currentQuestionIndex: number = 0;
  coverItemId !:string;
  dependentAfterAdditionalQuestion: any[]= [];
  @ViewChild("sliderRef") sliderRef!: ElementRef<HTMLElement>
   slider!: KeenSliderInstance;
  currentSlide: number = 0;
  ngUnsubscribe =  new Subject<void>();
  maxDate = new Date().toISOString().split('T')[0];
  selectedValues: { [claimQuestionId: string]: string[] } = {};
  reflectedPrice!: any;
  userId = "";
  fileClaimSubStep = FileClaimSubStep;
  fileClaimSubSteps = FileClaimSubStep.landingPage;

  displayedColumns: string[] = [
    "serviceAgreementNumber",
    "agreementStatus",
    "user",
    "planType",
    "propertyType",
    "propertySize",
    "coverageTerm",
    "agreementPrice",
    "netReceived",
    "balance",
    "createdOn",
    "waitingPeriod",
    "agreementEffectiveDate",
    "copaymentFee",
    "streetAddress",
    "city",
    "state",
    "zip",
    "mobileNumber",
    "emailAddress",
    "leadSource",
    "claimAction"
  ];
  dataSource = [];
  pageIndex = 0;
  pageSize = 30;
  totalCount = 0;
  searchType = "contains";
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  agreementNumber = '';
  creditCardList = [];
  counter = 0;
  
  constructor(
    public event: EventService,
    public apiService: ApiService,
    public storage: StorageService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private mapService: MapsService,
    private sidenavService: SidenavService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    public location: Location
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.sidenavService.close();
    }, 0);
    this.userId = this.activateRoute.snapshot.params["id"];
    if (this.userId) this.getUserDetails();
    this.agreementNumber = this.activateRoute.snapshot.queryParams?.agreementNumber;
    this.formInit();
    if(this.agreementNumber){
      this.step = 1;
      this.agreementNumberForm.get('agreementNumber').setValue(this.agreementNumber);
      this.checkAgreementNumberForm();
    }
    //Used for dynamic form
    this.beforeQuestionForm = this.fb.group({});
    this.afterQuestionForm = this.fb.group({});
    this.claimQuestionForm = this.fb.group({});
    this.firstQuestionsForm = this.fb.group({});

    this.getAllcoverItem();
    this.fetchAgreementsDetails();
    this.addressForm.get('phoneNumber')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res.startsWith('800') || res.startsWith('888') || res.startsWith('877') || res.startsWith('866') || res.startsWith('855') || res.startsWith('844') || res.startsWith('833')) {
        this.addressForm.controls['phoneNumber'].setErrors({ notValid: true });
      }
    });
    this.addressForm.get('address')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (!res) {
        this.addressForm.patchValue({
          zip: '',
          city: '',
          state: '',
        })
      }
    });
    this.cardDetailsForm.get('monthYear')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string) => {
      if (res) {
        if (res.length === 4) {
          this.cardDetailsForm.patchValue({
            expiryMonth: res.substring(0, 2),
            expiryYear: res.substring(2, 4),
          });
          if (
            this.cardDetailsForm.get("expiryYear").value ===
              this.expiryYear.toString() &&
            Number(this.cardDetailsForm.get("expiryMonth").value) < this.month
          ) {
            this.cardDetailsForm
              .get("expiryMonth")
              .setErrors({ notValid: true });
          }
        }
      }
    });

    this.otherAnswerForm.get('isOtherAnswer')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isOtherAnswer: boolean) => {
      const otherAnswerControl = this.otherAnswerForm.get('otherAnswer');
      if (otherAnswerControl) {
        if (isOtherAnswer) {
          otherAnswerControl.setValidators(Validators.required);
        } else {
          otherAnswerControl.clearValidators();
        }
        otherAnswerControl.updateValueAndValidity();
      }
    });
  };
  ngAfterViewInit(): void {
    if (this.homeAddress) {
      this.mapService.autoFillLocation(this.homeAddress, 'addressTrigger');
    }
    this.subs.push(
      this.mapService.getaddressEvent
      .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: any) => {
          if (res && typeof res === 'object' && res.root === 'addressTrigger') {
            this.addressForm.patchValue(res);
            this.addressForm.get('zip').setValue(res.zipcode)

          }
        })
    );
  }

  formInit() {
    this.agreementNumberForm = new FormGroup({
      agreementNumber : new FormControl('', [Validators.required]),
    })
    this.addressForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      phoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
      ]),
      emailAddress: new FormControl('', [
        Validators.required,
        Validators.pattern(
          /^[\w.-]+@[\w.-]+\.\w{2,3}$/
        ),
      ]),
      zip: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
    });

    this.cardDetailsForm = new FormGroup({
      cardNumber: new FormControl('', [Validators.required]),
      monthYear: new FormControl('', [Validators.required]),
      expiryMonth: new FormControl('', [Validators.required, Validators.max(12), Validators.min(1)]),
      expiryYear: new FormControl('', [Validators.required, Validators.min(this.expiryYear)]),
      cvv: new FormControl('', [Validators.required]),
      cardPayment: new FormControl('')
    });

    this.timeForm = new FormGroup({
      availability: new FormControl('', [Validators.required]),
      copaymentFee: new FormControl('', [Validators.required]),
    });

    this.coverItemForm = new FormGroup({
      coveredItemId: new FormControl('', [Validators.required]),
      subCoveredItemId: new FormControl('',),
      subCoveredItemChildId: new FormControl('',),
    });
    this.otherAnswerForm = new FormGroup({
      isOtherAnswer: new FormControl(false),
      otherAnswer: new FormControl(''),
    });
    this.issueDateForm = new FormGroup({
      issueDate : new FormControl('', [Validators.required])
    });

  };
  getAllcoverItem() {
    this.apiService.get(endpoints.fileAClaim.getPlanCoverItem).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res.body.planCoverItems) { 
        this.coverItems = res.body.planCoverItems?.data;
      }
    })
  };
  changeAddress() {
    this.submitFullForm = false;
    this.showZipcodeField = false;
  };
  checkAddress() {
    if (!this.addressForm.value?.address) {
      this.addressForm.controls['address'].markAsTouched();
      return null;
    }
    if (!this.addressForm.value.zip) {
      this.showZipcodeField = true;
    } else {
      this.showZipcodeField = false;
      this.submitFullForm = true;
    }
  };
  goBackToAddressSection(){
    this.showZipcodeField = false;
    this.addressForm.patchValue({zip : ''});
  };
  checkZipAndProceed() {
    if (!this.addressForm.value.zip) {
      this.addressForm.controls['zip'].markAsTouched();
    }
    if (this.addressForm.value?.zip && this.showZipcodeField && !this.submitFullForm) {
      this.chackZipCode();
    }
  };
  chackZipCode() {
    this.apiService
      .getCityState(this.addressForm.controls['zip'])
      .then((data) => {
        if (data) {
          this.addressForm.patchValue(data);
          this.addressForm.patchValue({
            address: `${this.addressForm.value?.address}, ${data?.zip}`
          })
          this.submitFullForm = true;
          this.showZipcodeField = false;
        } else {
          this.addressForm.controls['zip'].setErrors({ notValid: true });
          this.submitFullForm = false;
        }
      });
  };
  changeEmailAndSet() {
    this.addressForm.controls['emailAddress'].patchValue(this.addressForm.value.emailAddress.replace(/\s+/g, ''))
  };
  checkAgreementNumberForm(){
    if(this.agreementNumberForm.valid){
      this.apiService.get(endpoints.fileAClaim.getServiceAgreementDetails(this.agreementNumberForm.value?.agreementNumber)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
        if(res){
          let result = res?.body;
          if(result){
           this.addressForm.patchValue({
             firstName: result.agreement?.firstName,
             lastName: result.agreement?.lastName,
             emailAddress: result.agreement?.emailAddress,
             phoneNumber: result.agreement?.phoneNumber,
             address: `${result.agreement.coveredAddress?.streetAddress}, ${result.agreement.coveredAddress?.city}, ${result.agreement.coveredAddress?.state}, ${result.agreement.coveredAddress?.zip}`,
             city: result.agreement.coveredAddress?.city,
             zip: result.agreement.coveredAddress?.zip,
             state: result.agreement.coveredAddress?.state
           });
           if(result?.agreement?.orderPlanDetail?.orderMainPlanDetails?.coveredItems && result?.agreement?.orderPlanDetail?.orderMainPlanDetails?.coveredItems?.length > 0){
             this.coverItems = result?.agreement?.orderPlanDetail?.orderMainPlanDetails?.coveredItems.map((item:any)=>{
              return item?.coveredItems;
             })
           }
          
          }
          if(!this.agreementNumber) this.apiService.alert('You successfully find your agreement number', 'success');
          this.step = 1;
        }
      }, (err: HttpErrorResponse)=>{
        this.apiService.alert(err.error.message, ErrorType.Error);
      })
    } else {
      this.agreementNumberForm.markAllAsTouched();
    }
  }
  submitFirstStep() {
    if (this.addressForm.valid) {
      this.step = 2
    } else {
      this.addressForm.markAllAsTouched();
    }
  };
  checkSecondStep() {
    if (this.coverItemForm.valid && this.beforeQuestionForm.valid && this.afterQuestionForm.valid && this.claimQuestionForm.valid) {
      this.step = 3;
    } else {
      this.coverItemForm.markAllAsTouched();
      this.beforeQuestionForm.markAllAsTouched();
      this.afterQuestionForm.markAllAsTouched();
      this.claimQuestionForm.markAllAsTouched();
    }
  }
  checkCardDetails() {
    if (this.cardDetailsForm.valid) {
      const convertBeforeQuestion = Object.keys(this.beforeQuestionForm.value).map((key: any) => ({
        additionalQuestionId: key,
        answer: this.beforeQuestionForm.value[key]
      }));
      const convertAfterQuestion = Object.keys(this.afterQuestionForm.value).map((key: any) => ({
        additionalQuestionId: key,
        answer: this.afterQuestionForm.value[key]
      }));
      const convertFirstQuestion = Object.keys(this.firstQuestionsForm.value).map((key: any) => ({
        firstQuestionId: key,
        answer: this.firstQuestionsForm.value[key]
      }));
      const claimAnswerId = Object.keys(this.claimQuestionForm.value).map((key: any) => ({
        questionId: key,
        answerId: this.claimQuestionForm.value[key].filter((item: any) => item !== 'others')
      }));
      let formatedIssueData =  moment(this.issueDateForm.value?.issueDate).format("YYYY-MM-DD");

      let data: any = { ...this.addressForm.value, ...this.timeForm.value, ...this.agreementNumberForm.value };
      data.cardDetail = this.cardDetailsForm.value;
      data.coveredItemId = this.coverItemId;
      data.issueDate = formatedIssueData;
      data.claimAnswerId = claimAnswerId;
      let allAdditionalQuestions = [...convertBeforeQuestion, ...convertAfterQuestion];
      let filterQuestion = allAdditionalQuestions.filter(item => item.answer !== "");
      let filterFirstQuestion = convertFirstQuestion.filter(item => item.answer !== "");
      data.additionalQuestion = filterQuestion;
      data.firstQuestion = filterFirstQuestion;
      if(this.otherAnswerForm.value.isOtherAnswer){
        data = {...data, ...this.otherAnswerForm.value}
      } else {
        data.isOtherAnswer = this.otherAnswerForm.value.isOtherAnswer;
      }
      delete data?.cardDetail?.monthYear;
      delete data.cardDetail?.cardPayment;
      this.loading = true;
      this.apiService.post(endpoints.fileAClaim.submitFileAclaim, data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        if (res) {
          this.fileClaimNumber = res?.body?.fileClaimNumber;
          this.apiService.alert(res?.body?.message, 'success');
          this.step = 5;
          this.loading = false;
          this.messageAfterApiCall();
        }
      }, err => {
        this.apiService.alert(err.message, 'error');
        this.loading = false
      });
    } else {
      this.cardDetailsForm.markAllAsTouched();
    }
  };
  messageAfterApiCall() {
    setTimeout(() => {
      this.showZipcodeField = false;
      this.submitFullForm = false;
      this.formInit();
      this.beforeQuestionForm = this.fb.group({});
      this.afterQuestionForm = this.fb.group({});
      this.claimQuestionForm = this.fb.group({});
      this.firstQuestionsForm = this.fb.group({});
      this.step = 0;
      this.subStepTwo = 1;
      this.cardType = '';
      this.showSubCoverItemChild = false;
      this.showFirstQuestionForm = false;
      this.showSubCoverItem = false;
      this.subCoverItemDetails = null;
      this.subCoverChildDetais = null;
      this.currentQuestionIndex = 0;
      this.fileClaimSubSteps = FileClaimSubStep.landingPage;
      this.reflectedPrice = null;
    }, 90000);
  }
  checkTimeForm() {
    if (this.timeForm.valid) {
      this.step = 4
    } else {
      this.timeForm.markAllAsTouched();
    }
  };
  redioChange(e: any) {
    if(!this.reflectedPrice){
      this.commonChange(e);
    }
   
  };
  commonChange(e: any){
    if (e.target.value === 'After Hours: 6 - 10 PM') {
      this.timeForm.patchValue({
        copaymentFee: 150
      })
    } else {
      this.timeForm.patchValue({
        copaymentFee: 70
      })
    }
  };
  
  coverItemChange(e: any) {
    let coverItemId = e.target.value;
    const subCoveredItemChildId = this.coverItemForm.get('subCoveredItemChildId');
    subCoveredItemChildId?.clearValidators();
    subCoveredItemChildId?.updateValueAndValidity();
    this.showSubCoverItemChild = false;
    this.checkedSubCoverItem(coverItemId);
    this.coverItemForm.patchValue({subCoveredItemId: ''});
    this.counter = 0;
  };
  checkedSubCoverItem(id: any){
    if(id){
      let coveredItem = this.coverItems.find((item: any)=> item?.planCoverItemId === id);
      const subCoverItemId = this.coverItemForm.get('subCoveredItemId');
      this.subCoverItems  = coveredItem?.subCoveredItem;
   if(subCoverItemId){
    if(coveredItem?.subCoveredItem?.length){
      this.showSubCoverItem = true;
      subCoverItemId.setValidators(Validators.required);
      subCoverItemId.updateValueAndValidity();
     } else {
      this.showSubCoverItem = false;
      subCoverItemId.clearValidators();
      subCoverItemId.updateValueAndValidity();
      this.genDynamicForm(id, 'coverItem');
      this.coverItemId = id;
     }
   }
    }
  };
  subCoverItemChange(e : any){
    this.counter = 0;
    let subCoverItemId = e.target.value;
    let subCoverItem = this.subCoverItems.find((item: any)=> item?.planSubCoverItemId === subCoverItemId);
    const subCoveredItemChildId = this.coverItemForm.get('subCoveredItemChildId');
    this.subCoverItemDetails = subCoverItem;
    this.subCoverItemChild = subCoverItem.subCoveredItem;
    if(subCoveredItemChildId){
      if(subCoverItem.subCoveredItem?.length){
        this.showSubCoverItemChild = true;
        subCoveredItemChildId.setValidators(Validators.required);
        subCoveredItemChildId.updateValueAndValidity();
      } else {
        this.showSubCoverItemChild = false;
        if(subCoverItemId){
          subCoveredItemChildId.clearValidators()
          subCoveredItemChildId.updateValueAndValidity();
          this.genDynamicForm(subCoverItemId, 'subCoverItem');
          this.coverItemId = subCoverItemId;
        }
      }  
    }
  };
  subCoverItemChildChange(e: any){
    this.counter = 0;
   let subCoverItemid = e.target.value;
  this.subCoverChildDetais = this.subCoverItemChild.find((item)=> item?.planSubCoverItemId === e.target.value);
   
   if(subCoverItemid){
    this.genDynamicForm(subCoverItemid, 'subCoverItemChild');
    this.coverItemId = subCoverItemid;
   }
  }
  genDynamicForm(id: string, type: string){
    if(id){
      this.beforeQuestionForm = this.fb.group({});
      this.afterQuestionForm = this.fb.group({});
      this.claimQuestionForm = this.fb.group({});
      this.issueDateForm.reset();
      this.getClaimQuestions(id, type);
      this.getFirstQuestions(id);
      this.getAfterAdditionalQuestion(id);
      this.getBeforeAdditionalQuestion(id);
      this.otherAnswerForm.patchValue({
        isOtherAnswer: false,
        otherAnswer: '',
      }); 
      this.isOtherAnswer = false;
      this.beforeQuestionAnswer = [];
      this.claimQuestionAnswer = [];
      this.afterQuestionAnswer = [];
    }
  }
  getClaimQuestions(id: string, type: string) {
    this.apiService.get(endpoints.fileAClaim.claimQuestion(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res) {
        this.counter = this.counter + 1;
        this.claimQuestion = res?.body?.ClaimQuestion;
        this.claimQuestion.forEach(question => {
          const control = this.fb.control('', [Validators.required]);
          this.claimQuestionForm.addControl(question.question.claimQuestionId, control);
        });
        if (this.claimQuestion.length === 0) {
          if(type === 'coverItem') this.coverItemForm.controls['coveredItemId'].setErrors({ notValid: true });
          else if(type === 'subCoverItem') this.coverItemForm.controls['subCoveredItemId'].setErrors({ notValid: true });
          else if(type === 'subCoverItemChild') this.coverItemForm.controls['subCoveredItemChildId'].setErrors({ notValid: true });
        }
      }
    },
  (err: HttpErrorResponse)=>{
    this.counter = this.counter + 1;
    this.apiService.alert(err.message, ErrorType.Error);
  })
  };
  getAfterAdditionalQuestion(id: string) {
    this.apiService.get(endpoints.fileAClaim.getAfterAdditionalQuestion(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res) {
        this.afterQuestion = res?.body?.claimAddtionalQuestion;
        this.counter = this.counter + 1;
        this.afterQuestion.forEach(question => {
          const validators = question.isRequired ? [Validators.required] : [];

          const control = this.fb.control('', validators);
          this.afterQuestionForm.addControl(question.additionalQuestionId, control);
        });
      }
    }, (err: HttpErrorResponse)=>{
      this.counter = this.counter + 1;
      this.apiService.alert(err.message, ErrorType.Error);
    })
  };
  getBeforeAdditionalQuestion(id: string) {
    this.apiService.get(endpoints.fileAClaim.getBeforeAdditionalQuestion(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res) {
        this.beforeQuestion = res?.body?.claimAddtionalQuestion;
        this.counter = this.counter + 1;
        this.beforeQuestion.forEach(question => {
          const validators = question.isRequired ? [Validators.required] : [];

          const control = this.fb.control('', validators);
          this.beforeQuestionForm.addControl(question.additionalQuestionId, control);
        });
      }
    }, (err: HttpErrorResponse)=>{
      this.counter = this.counter + 1;
      this.apiService.alert(err.message, ErrorType.Error);
    })
  };
  getFirstQuestions(id : string){
    this.apiService.get(endpoints.fileAClaim.getFirstQuestions(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      this.firstQuestionsForm = this.fb.group({});
      if(res){
        this.firstQuestions = res?.body?.claimAddtionalQuestion;
        this.updateFormControls();
        this.counter = this.counter + 1;
      }
    }, (err: HttpErrorResponse)=>{
      this.counter = this.counter + 1;
      this.apiService.alert(err.message, ErrorType.Error);
    })
  };
  checkeAdditianalQuestion(value: boolean, id: string, type: string, index: number){
    this.getChildAdditionalQuestionByParents(id, value, type, index);
  }

  getChildAdditionalQuestionByParents(additionalQuestionlId: string, value: boolean, type: string, index: number){
    this.apiService.get(endpoints.fileAClaim.getChildAdditionalQuestionByParents(additionalQuestionlId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      const claimAddtionalQuestion =  res?.body?.claimAddtionalQuestion;
      this.dependentAfterAdditionalQuestion = claimAddtionalQuestion;
      if(type === 'afterQuestion'){
        const filterAfterAdditionalQuestion = this.afterQuestion.filter(item => {
          return !claimAddtionalQuestion.some((removeItem: any) => removeItem.additionalQuestionId === item.additionalQuestionId);
      });
      this.removeAfterQuestionControll();
      this.afterQuestion = filterAfterAdditionalQuestion;
      this.dependAdditionalQuestion(res, value, index, true);
      } else {
        const filterBeforeAdditionalQuestion = this.beforeQuestion.filter(item => {
          return !claimAddtionalQuestion.some((removeItem: any) => removeItem.additionalQuestionId === item.additionalQuestionId);
      });
      this.removeBeforeQuestionControll();
      this.beforeQuestion = filterBeforeAdditionalQuestion;
      this.dependAdditionalQuestion(res, value, index, false);
      }
      
    })
  };
  dependAdditionalQuestion(res: any, value: boolean, index: number, isAfter: boolean){
    let dependAdditionalQuestion : any[] = res?.body?.claimAddtionalQuestion.filter((item: any)=>{
      if(value){
        return item?.dependentOnAnswer === 'Yes'
      } else{
        return item?.dependentOnAnswer === 'No'
      }
    })
    if(isAfter){
      dependAdditionalQuestion.forEach((item: any)=> {
        this.afterQuestion.splice(index + 1, 0, item);
        this.afterQuestionDynamiControll(item);
      })
    } else {
      dependAdditionalQuestion.forEach((item: any)=> {
        this.beforeQuestion.splice(index + 1, 0, item)
        this.beforeQuestionDynamiControll(item);
      })
    }
   
  }
  afterQuestionDynamiControll(question: any){
    const validators = question.isRequired ? [Validators.required] : [];
    const control = this.fb.control('', validators);
    this.afterQuestionForm.addControl(question.additionalQuestionId, control);
  };
  removeAfterQuestionControll(){
    this.dependentAfterAdditionalQuestion.map((item: any)=>{
      this.afterQuestionForm.removeControl(item?.additionalQuestionId);
    })
  };
 beforeQuestionDynamiControll(question: any){
    const validators = question.isRequired ? [Validators.required] : [];
    const control = this.fb.control('', validators);
    this.beforeQuestionForm.addControl(question.additionalQuestionId, control);
  };
  removeBeforeQuestionControll(){
    this.dependentAfterAdditionalQuestion.map((item: any)=>{
      this.beforeQuestionForm.removeControl(item?.additionalQuestionId);
    })
  }
 
  updateFormControls() {
    this.firstQuestions.forEach((question, index) => {
      const validators = question.isRequired ? [Validators.required] : [];
      const control = this.fb.control('', validators);
      this.firstQuestionsForm.addControl(question.firstQuestionId, control);
    });
  }

  checkFirstQuestionFormContinue() {
    
    const currentQuestionId = this.firstQuestions[this.currentQuestionIndex].firstQuestionId;
    const currentFormControl = this.firstQuestionsForm.get(currentQuestionId);
    if(this.currentQuestionIndex === this.firstQuestions.length - 1 && this.firstQuestionsForm.valid){
    if (this.beforeQuestion.length === 0) {
      this.subStepTwo = 3;
    } else {
      this.subStepTwo = 2;
    }
    this.sliderInit();
    return;
  }
  if(currentFormControl){
    if (currentFormControl.valid) {
      if (this.currentQuestionIndex < this.firstQuestions.length - 1) {
        this.currentQuestionIndex++;
        this.updateFormControls();
      }
    } else {
      currentFormControl.markAsTouched();
    }
  };  
  }


  checkFirstQuestionFormBack() {
    if(this.currentQuestionIndex === 0) this.showFirstQuestionForm = false;
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  isCurrentQuestion(index: number): boolean {
    return index === this.currentQuestionIndex;
  }  

  getCoverItemDetails(id: string) {
    this.loading = true;
    this.coverItemDetails = this.coverItems.find((item) => item?.planCoverItemId === id);
    this.apiService.get(endpoints.fileAClaim.getCoverItemDetails(id)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res) {
        // this.coverItemDetails = res?.body?.planCoverItem;
        this.loading = false;
        this.step = 2;
        if(this.firstQuestions.length){
          this.showFirstQuestionForm = true;
        } else {
          this.showFirstQuestionForm = false;
          if (this.beforeQuestion.length === 0) {
            this.subStepTwo = 3;
          } else {
            this.subStepTwo = 2;
          }
          this.sliderInit();
        }
      }

    }, (err: HttpErrorResponse) => {
      this.loading = false;
      this.apiService.alert(err.error?.message, "error");
    })
  }

  checkSubSecondStepOne() {
    if (this.coverItemForm.valid) {
      this.getCoverItemDetails(this.coverItemForm.value?.coveredItemId);
    } else {
      this.coverItemForm.markAllAsTouched();
    }
  };

  checkSubSecondStepTwo() {
    if (this.beforeQuestionForm.valid) {
      this.beforeQuestionAnswer = [];
      this.step = 2;
      this.subStepTwo = 3;
      this.beforeQuestion.forEach(question => {
        const answer = this.beforeQuestionForm.get(question.additionalQuestionId)?.value;
        const formattedAnswer = question.type === 'Yes/No' && typeof answer === 'boolean'
          ? (answer ? 'Yes' : 'No') : question.type === 'Date' && answer ? (moment(answer).format("YYYY-MMM-DD"))
          : answer;
          if(formattedAnswer){
            this.beforeQuestionAnswer.push({ question: question.title, answer: formattedAnswer });
          }
      });
      this.timeForm.patchValue({availability : ''});
    } else {
      this.beforeQuestionForm.markAllAsTouched();
    }
  };

  checkSubSecondStepThree() {
    if (this.claimQuestionForm.valid && this.otherAnswerForm.valid && this.issueDateForm.valid) {
      this.claimQuestionAnswer  = this.claimQuestion.map(question => {
        const selectedValue = this.claimQuestionForm.get(question.question.claimQuestionId)?.value || [];
        const selectedAnswers = question.questionAnswers
          .filter((answer: any) => selectedValue.includes(answer.answer.claimQuestionAnswerId))
          .map((answer: any) => answer.answer.answer);
    
        return {
          question: question.question.question,
          answer: selectedAnswers
        };
      });
    
      // this.step = 2;
      if (this.afterQuestion.length === 0) {
        this.step = 3
      } else {
        this.step = 2;
        this.subStepTwo = 4;
      }
    } else {
      this.claimQuestionForm.markAllAsTouched();
      this.otherAnswerForm.markAllAsTouched();
      this.issueDateForm.markAllAsTouched();
    }
   
  };
  

  toggleAnswer(questionId: string, answerId: string, event: any) {
    if (event.target.checked) {
      if (!this.selectedValues[questionId]) {
        this.selectedValues[questionId] = [];
      }
      this.selectedValues[questionId].push(answerId);
    } else {
      if (this.selectedValues[questionId]) {
        const index = this.selectedValues[questionId].indexOf(answerId);
        if (index !== -1) {
          this.selectedValues[questionId].splice(index, 1);
        }
      }
    }
    if(answerId === 'others'){
      this.isOtherAnswer = event.target.checked;
      this.otherAnswerForm.patchValue({
        isOtherAnswer: this.isOtherAnswer,
      })
    }
    const selectedClaimData = this.getSelectedValues();
    this.claimQuestionForm.patchValue(selectedClaimData);
  }
  
  getSelectedValues(): { [claimQuestionId: string]: string[] } {
    return this.selectedValues;
  }
  

  checkSubSecondStepFore() {
    if (this.afterQuestionForm.valid) {
      this.afterQuestionAnswer = [];
      this.step = 3;
      this.afterQuestion.forEach(question => {
        const answer = this.afterQuestionForm.get(question.additionalQuestionId)?.value;
        const formattedAnswer = question.type === 'Yes/No' && typeof answer === 'boolean'
          ? (answer ? 'Yes' : 'No') : question.type === 'Date' && answer ? (moment(answer).format("YYYY-MMM-DD"))
          : answer;
          if(formattedAnswer){
            this.afterQuestionAnswer.push({ question: question.title, answer: formattedAnswer });
          };
      });
     this.timeForm.patchValue({availability : ''})
    } else {
      this.afterQuestionForm.markAllAsTouched();
    }
  };
  checkClaimQuestionBack() {
    if (this.beforeQuestion.length === 0) {
      this.subStepTwo = 1
    } else {
      this.subStepTwo = 2
    }
  }
  back() {
    this.step = (this.step - 1);
  }
  beforeQuestionBack() {
    this.subStepTwo = 1;
  }
  getCardType(cardNumber: string): string {
    const cardNumberDigitsOnly = cardNumber?.replace(/\D/g, '');
    const firstDigit = cardNumberDigitsOnly?.charAt(0);
    if (firstDigit === '4') {
      return 'Visa';
    } else if (firstDigit === '5') {
      return 'Mastercard';
    } else if (firstDigit === '3') {
      return 'American Express';
    } else if(firstDigit === '6'){
      return 'Discover'
    } else {
      return 'Unknown';
    }
  }

  detectCardType(cardNumber: string) {
    this.cardType = this.getCardType(cardNumber);
  };

  openOthers(){
    this.isOtherAnswer = !this.isOtherAnswer;
    this.otherAnswerForm.patchValue({
      isOtherAnswer: this.isOtherAnswer,
    })
  };

  sliderInit(){ 
    setTimeout(()=>{
      this.slider = new KeenSlider(
        this.sliderRef.nativeElement,
        {
          slides: {
            perView: 1,
          },
          loop: false,
          initial: this.currentSlide,
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel
          },
        },
      );
    }, 200)
  };

  checkReflectedPriceYesNoQuestion(questionType: string, questionId: string,  value: boolean){
    let question: any;
    if(questionType === 'beforeQuestion'){
      question = this.beforeQuestion.find((item: any)=> item.additionalQuestionId === questionId);
    } else {
      question = this.afterQuestion.find((item: any)=> item.additionalQuestionId === questionId);
    }
   if(question && question.reflectedPrice){
    if(value){
      this.timeForm.patchValue({copaymentFee: question.reflectedPrice?.yes || ''});
      this.reflectedPrice = question.reflectedPrice?.yes || null;
    } else {
      this.timeForm.patchValue({copaymentFee: question.reflectedPrice?.no || ''});
      this.reflectedPrice = question.reflectedPrice?.no || null;
    }
    
   }
  };
  checkReflectedPriceDropDownQuestion(questionType: string, questionId:string , event: any){
    const value = event.target.value.replace(/\s/g, '_');
    let question: any;
    if(questionType === 'beforeQuestion'){
      question = this.beforeQuestion.find((item: any) => item.additionalQuestionId === questionId);
    } else {
      question = this.afterQuestion.find((item: any) => item.additionalQuestionId === questionId);
    }
    if(question && question?.reflectedPrice){
      this.reflectedPrice = question.reflectedPrice[value] || null;
      this.timeForm.patchValue({copaymentFee: this.reflectedPrice})
    }
  };
  openFindAgreementModal(){
    let dialogRef = this.dialog.open(FindAgreementNumberModalComponent,
      {
        width:'600px',
        disableClose: true
      }
    );
    dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
     if(result) this.agreementNumberForm.patchValue({agreementNumber: result});
    });
  }
 
  
  fetchAgreementsDetails() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.getCustomerAgreements(
          this.userId
        )}?page=${this.pageIndex + 1}&searchType=${this.searchType}&size=${
          this.pageSize
        }`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.dataSource = res.body.agreements.data;
          this.totalCount = res.body?.agreements?.total;
        },
        () => {
          this.dataSource = [];
          this.totalCount = 0;
        }
      );
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchAgreementsDetails();
  }
  getAgreementNumber(event: any){
    this.agreementNumberForm.patchValue({agreementNumber: event?.agreementNumber});
    this.step = 0; this.fileClaimSubSteps = this.fileClaimSubStep.AgreementNumberPage
  }
  getUserDetails() {
    this.apiService
      .get(endpoints.customerDashboard.getUser(this.userId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
       if(res.body){
        this.creditCardList = res.body?.user?.userPaymentDetail;
        const defaultCard = res.body?.user?.userPaymentDetail.find((card: {isDefault: boolean})=> card.isDefault);
        if(defaultCard){
          this.cardType = defaultCard?.cardDetails?.cardType;
          this.cardDetailsForm.get('cardPayment').setValue(defaultCard?.cardDetails?.cardNumber);
          setTimeout(()=>{
            this.patchCardDetails(defaultCard);
           }, 200);
        }
        
       }
      }, (err: HttpErrorResponse)=>{
        this.apiService.alert(err.message, ErrorType.Error);
      }
    );
  }
  patchCardDetails(cardDetails: any){
    this.cardDetailsForm.patchValue({
      // cardHoldarName: defaultCard?.cardDetails?.cardHolderName,
      cardNumber: cardDetails?.cardDetails?.cardNumber,
      cvv: cardDetails?.cardDetails?.cvv,
      monthYear: `${
        cardDetails?.cardDetails?.expiryMonth
      }${cardDetails?.cardDetails?.expiryYear.substring(2, 4)}`,
    });
  }
  onCardChange(event: any){
    if(!event?.target?.value){
      this.cardDetailsForm.reset();
      this.cardDetailsForm.get('cardPayment').setValue('');
      this.cardType = '';
      return;
    }
    const selectedCard = this.creditCardList.find((card: any)=> card?.cardDetails?.cardNumber === event?.target?.value);
    this.cardType = selectedCard?.cardDetails?.cardType;
   setTimeout(()=>{
    this.patchCardDetails(selectedCard);
   }, 200);
  }
  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}